import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/complaintManage/list',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/complaintManage/insert',
    method: 'post',
    data: data
  });
}
export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/complaintManage/delete',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/complaintManage/update',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/complaintManage/get',
    method: 'post',
    data: data
  });
} // 工单号详情

export function fetchFlowDetail(data) {
  return request({
    url: '/pmsservice/api/complaintManage/getRepairManageInfoByFlowNum',
    method: 'post',
    data: data
  });
} // 派工

export function fetchDispatch(data) {
  return request({
    url: '/pmsservice/api/complaintManage/distributeLeaflets',
    method: 'post',
    data: data
  });
} // 完成

export function fetchFinish(data) {
  return request({
    url: '/pmsservice/api/complaintManage/serverFinish',
    method: 'post',
    data: data
  });
} // 转派

export function fetchTransfer(data) {
  return request({
    url: '/pmsservice/api/complaintManage/transferRepairOrder',
    method: 'post',
    data: data
  });
}